import _factory from './_factory';

export default {
  ..._factory('movies'),
};
